<template>
  <div class="animated fadeIn">
    <SubHeaderUserManagement></SubHeaderUserManagement>
    <TableUsers :loading="isLoading"/>
  </div>
</template>

<script>
import SubHeaderUserManagement from '../../../components/subHeaders/SubHeaderUserManagement';
import TableUsers from '../../../components/users/TableUsers';
import consts from '../../../_consts';
import {mapGetters} from 'vuex';
export default {
  name: 'user-management-view',
  components: {
    TableUsers,
    SubHeaderUserManagement
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'GETTER_GET_IS_LOADING'
    })
  },
  created () {
    this.$store.dispatch('ACTION_GET_ALL_USERS');
    this.$store.commit('MUTATION_SET_MANAGER_VIEW', consts.viewNames.managerUsers);
  }
};
</script>


<style>

</style>



// WEBPACK FOOTER //
// UserManagement.vue?4ab1b76c